<template>
  <!-- eslint-disable vue/valid-v-model -->
  <div
    class="tr-image"
    :style="getImageStyle()"
    v-model="imageModel"
    @click="clickAction($event)"
    :class="[
      { 'image-disabled': imageDataModel.block === true },
      { 'image-rest': imageModel === 'rest' },
      { 'image-selected': imageModel === 'selected' },
      { 'image-correct': imageModel === 'correct' },
      { 'image-wrong': imageModel === 'incorrect' },
    ]"
  ></div>
  <!-- eslint-enabl vue/valid-v-model -->
</template>
<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
export default {
  name: 'tr-image',
  components: {},
  props: {
    imageDataModel: {
      type: Object,
      default: function () {
        return { index: 0, correct: false, block: false, status: 'rest' };
      },
    },
    imagePath: {
      type: String,
      default: function () {
        return '';
      },
    },
    offsetVertical: {
      type: null,
      default: function () {
        return 0;
      },
    },
    offsetHorizontal: {
      type: null,
      default: function () {
        return 0;
      },
    },
    scaleImage: {
      type: Number,
      default: function () {
        return null;
      },
    },
    pos: {
      type: Object,
      default: function () {
        return { x: 0, y: 0 };
      },
    },
    items: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    getImageStyle(imageData) {
      let style = {
        position: this.pos && this.pos.y ? 'absolute' : 'inherit',
        'pointer-events': this.pos && this.pos.y ? 'auto' : 'none',
        cursor: this.pos && this.pos.y ? 'pointer' : 'default',
        'background-size': _.isNil(this.scaleImage) ? 'contain' : ['auto', ' ', this.scaleImage, '%'].join(''),
        'background-image': "url('static/" + this.imagePath + "')",
        top: this.pos && this.pos.y ? utils.elementTopPosition(this.pos.y, this.offsetVertical, this.pos.unit) : '',
        left: this.pos && this.pos.x ? utils.elementLeftPosition(this.pos.x, this.offsetHorizontal, this.pos.unit) : '',
        width: this.pos && this.pos.y ? utils.elementWidth(this.pos.width, this.pos.unit) : '100%',
        height: this.pos && this.pos.y ? utils.elementHeight(this.pos.height, this.pos.unit) : '100%',
      };
      return style;
    },
    clickAction(event) {
      this.resetCheckStatus();
      this.$emit('trClick', event, this.imageDataModel.index);
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
  },
  computed: {
    imageModel: {
      get() {
        return this.imageDataModel.status;
      },
      set(newValue) {
        if (!this.imageDataModel.block) {
          this.imageDataModel.status = newValue;
        }
      },
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
$hoverColor: rgb(236, 158, 40);
$selectColor: rgb(182, 29, 190);
$correctColor: rgb(52, 180, 107);
$incorretColor: rgb(228, 8, 21);
.tr-image {
  cursor: pointer;
  position: absolute;
  background-repeat: no-repeat;
  background-position: center;
}
.image-rest {
}
.image-disabled {
  pointer-events: none;
}
.image-selected {
  box-shadow: inset 0 0 20px 3px $selectColor;
}
.image-correct {
  box-shadow: inset 0 0 20px 3px $correctColor;
}
.image-wrong {
  box-shadow: inset 0 0 20px 3px $incorretColor;
}
</style>
